/**
 * URL parameter utilities for OAuth callback handling
 */

export interface CallbackParams {
  code?: string
  state?: string
  realmId?: string
  error?: string
  error_description?: string
}

/**
 * Parse URL parameters from current location
 */
export function parseCallbackParams(): CallbackParams {
  const params = new URLSearchParams(window.location.search)
  
  return {
    code: params.get('code') || undefined,
    state: params.get('state') || undefined,
    realmId: params.get('realmId') || undefined,
    error: params.get('error') || undefined,
    error_description: params.get('error_description') || undefined,
  }
}

/**
 * Clean URL by removing query parameters (for security)
 */
export function cleanUrl(): void {
  if (window.history && window.history.replaceState) {
    const cleanUrl = window.location.pathname + window.location.hash
    window.history.replaceState({}, document.title, cleanUrl)
  }
}